import { Box, IconButton, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterXIconBlue from '../../../../static/twitterXIconBlue.svg';

export enum SocialMediaTypes {
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Twitter = 'twitter',
}

const generateSocialButton = (
  platform: SocialMediaTypes,
  onClick: () => void,
) => {
  const renderIcon = (type: SocialMediaTypes) => {
    switch (type) {
      case SocialMediaTypes.Facebook:
        return <FacebookIcon />;
      case SocialMediaTypes.Linkedin:
        return <LinkedInIcon />;
      case SocialMediaTypes.Twitter:
          return <TwitterXIconBlue />;
    }
  };

  return (
    <IconButton
      color={'inherit'}
      size={'small'}
      onClick={onClick}
      key={platform}
      role="button"
      data-testid={`btn-${platform}`}
    >
      {renderIcon(platform)}
    </IconButton>
  );
};

const socialShare = (
  platform: SocialMediaTypes,
  title: string,
  slug: string,
) => {
  if (typeof window === 'undefined') {
    return;
  }

  const encodedTitle = encodeURIComponent(title);
  const SharingURL = window.location.origin
    ? encodeURIComponent(window.location.origin + slug)
    : '';

  const SOCIAL_SHARER_LINKS = {
    [SocialMediaTypes.Facebook]: `https://www.facebook.com/sharer/sharer.php?u=${SharingURL}`,
    [SocialMediaTypes.Linkedin]: `https://www.linkedin.com/shareArticle?mini=true&url=${SharingURL}`,
    [SocialMediaTypes.Twitter]: `https://twitter.com/intent/tweet?url=${SharingURL}&text=${encodedTitle}`,
  };

  window.open(SOCIAL_SHARER_LINKS[platform], '_blank', 'noreferrer, noopener');
};

interface SocialShareProps {
  title: string;
  slug: string;
}

const SocialShareLinks: FC<SocialShareProps> = (props: SocialShareProps) => {
  const { t } = useTranslation();
  const { title, slug } = props;

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      marginTop="1rem"
    >
      <Typography
        variant={'body1'}
        style={{ fontWeight: 700, fontSize: '14px', marginBottom: 10, textTransform: 'uppercase' }}
      >
        {t('SHARE_THIS_BLOG_ON')}
      </Typography>
      <Box 
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '12px'
        }}
      >
        { 
          [
            SocialMediaTypes.Facebook,
            SocialMediaTypes.Linkedin,
            SocialMediaTypes.Twitter,
          ].map((type: SocialMediaTypes) =>
            generateSocialButton(type, () =>
              socialShare(type, title, slug),
            ),
        )}
      </Box>
    </Box>
  );
};
export default SocialShareLinks;
